import * as React from "react";
import PropTypes from "prop-types";

const SlideContext = React.createContext(null);

export const useSlideContext = () => {
  const context = React.useContext(SlideContext);
  if (!context) {
    throw new Error("useSlideContext must be used within a SlideProvider");
  }
  return context;
};

export const SlideProvider = ({ children, value }) => {
  return <SlideContext.Provider value={value}>{children}</SlideContext.Provider>;
};

SlideProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.shape({
    goTo: PropTypes.func.isRequired,
    setProp: PropTypes.func.isRequired,
    props: PropTypes.object.isRequired,
    pptFrame: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
    }).isRequired,
    setPPTFrame: PropTypes.func.isRequired,
  }).isRequired,
};
